import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { underlineLinkStyle } from '@bingads-webui-campaign-react/common-styles';
import { AdjustmentType } from './adjustment-type';

const getDescriptionStyle = (_, { palette = {} }) => ({
  description: {
    marginTop: 10,
    marginBottom: 10,
    paddingLeft: 32,
    '& span': {
      whiteSpace: 'nowrap',
      ...underlineLinkStyle({ palette }),
    },
  },
});

const DescriptionBanner = ({ classes, i18n, adjustmentType }) => (
  <div className={classNames('description-banner', classes.description)}>
    {adjustmentType === AdjustmentType.SeasonalityAdjustment ?
      <LearnMoreLink
        linkText={i18n.getString(_TL_('Learn more'))}
        text={i18n.getString(_TL_('Optimize your bids for a short period of time when you expect significant changes to conversion rates, such as a sale or promotion.'))}
        topic="app54812"
      />
      :
      <LearnMoreLink
        linkText={i18n.getString(_TL_('Learn more'))} // Display the content once it's ready
        text={i18n.getString(_TL_('Use data exclusions for short  periods of time when you need to exclude conversion data from your auto-bidding strategy\'s calculation.'))}
        topic="app54822"
      />
    }
  </div>
);

DescriptionBanner.propTypes = {
  classes: PropTypes.shape({
    disclaimer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  adjustmentType: PropTypes.oneOf([AdjustmentType.DataExclusion, AdjustmentType.SeasonalityAdjustment]).isRequired,
};

export const StyledDescriptionBanner = withDefaultStyles(
  withI18nConsumer(DescriptionBanner),
  getDescriptionStyle
);
